module.exports = __webpack_public_path__ + "img/part5-14.4e597e38.png";